import * as CubiqTS from "shared/cubiq-model-multi-asset";

function generateUUID() {
  let d = new Date().getTime();
  let d2 = (performance && performance.now && performance.now() * 1000) || 0;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    let r = Math.random() * 16;
    if (d > 0) {
      // eslint-disable-next-line no-bitwise
      r = (d + r) % 16 | 0;
      // eslint-disable-next-line no-bitwise
      d = Math.floor(d / 16);
    } else {
      // eslint-disable-next-line no-bitwise
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    // eslint-disable-next-line no-bitwise
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export class BfxHedgeOrderStagingRow {
  private static internalIdCounter: number = 0;

  public readonly id: string;

  public locked: boolean = true;
  public orderState: string = null;
  public errors: any = null;
  public processing: boolean = false;
  public submitted: boolean = false;
  public bulkEditRow: boolean = false;

  private _orderQty: CubiqTS.BigNumber;

  constructor(
    public orderRequest: CubiqTS.FixingOrderRequestDataImpl,
    public startTime?: CubiqTS.Moment,
    public endTime?: CubiqTS.Moment,
    public algoHedgeConfig?: CubiqTS.AlgoHedgeConfigInfoImpl,
    public traderGroup?: CubiqTS.TradingGroupImpl,
  ) {
    this.id = generateUUID();
    this.orderRequest.externalClientReference = this.id;
    try {
      this._orderQty = new CubiqTS.BigNumber(orderRequest.fixedAmount);
    } catch (error) {
      this._orderQty = null;
    }
  }

  public roundToMillion(): CubiqTS.RoundToMillionsType {
    return this.traderGroup != null
      ? this.traderGroup.roundToMillionsType
      : CubiqTS.RoundToMillionsType.DISABLED;
  }

  public isAlgo(): boolean {
    return this.orderRequest.orderType == CubiqTS.OrderType.BMALGO;
  }

  public get orderQty(): CubiqTS.BigNumber {
    return this._orderQty;
  }

  public set orderQty(value: CubiqTS.BigNumber) {
    this._orderQty = value;
    this.orderRequest.fixedAmount = value ? value.toString() : "";
  }

  public clone(): BfxHedgeOrderStagingRow {
    let copyOrderRequest = Object.assign(
      new CubiqTS.FixingOrderRequestDataImpl(),
      this.orderRequest,
    );

    if (this.orderRequest.strategyParameters != null) {
      copyOrderRequest.strategyParameters = this.orderRequest.strategyParameters.map(
        (param: CubiqTS.StrategyParameterImpl) =>
          Object.assign(new CubiqTS.StrategyParameterImpl(), param),
      );
    }

    let startTime: CubiqTS.Moment = this.startTime != null ? CubiqTS.moment(this.startTime) : null;
    let endTime: CubiqTS.Moment = this.endTime != null ? CubiqTS.moment(this.endTime) : null;

    let clonedRow: BfxHedgeOrderStagingRow = new BfxHedgeOrderStagingRow(
      copyOrderRequest,
      startTime,
      endTime,
      this.algoHedgeConfig,
      this.traderGroup,
    );
    clonedRow.locked = false;

    return clonedRow;
  }
}
